module.exports = __webpack_public_path__ + "images/sns_campaign_lp/mainvisual-present-1-sp_11506bc641a4ffe5ff903edd1d88bd2f.png";